import React, { memo, useEffect, useCallback, useState } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';
import { getMineSetupList, cancelMineCollectOrSetup } from '../../../actions/wallpaperPay';
import WallpaperCard from '../../../components/WallpaperCard/WallpaperCard';
import InfiniteScroll from 'react-infinite-scroller';
import Blank from '../Blank';
import styles from './Setup.module.less';
import hint from '../../../static/wp_blank.png';
import { logging, logPostInfo } from '../../../actions/log';
import ScrollTopWhite from '../../../components/ScrollTopWhite/ScrollTopWhite';
import BatchAdd from '../WallpaperComponents/BatchAdd';
import { determineBatchShow, showBatchAddInfo } from '../../../actions/wallpaper';
import config from '../config';

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectMineInfo = createSelector(
  state => {
    return state.wallpaperPay;
  },
  info => {
    return info.mineSetupInfo;
  },
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const SelectWpBatchAddShow = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpBatchAddShow,
);

export default memo(({ node }) => {
  const userInfo = useSelector(selectUserInfo);
  const dispatch = useDispatch();
  const mineInfo = useSelector(selectMineInfo);
  const [showNumber, setShowNumber] = useState(3);
  const logInfoData = useSelector(selectLogInfo);
  const wpBatchAddShow = useSelector(SelectWpBatchAddShow);

  useEffect(() => {
    if (userInfo && userInfo.st) {
      dispatch(
        getMineSetupList({
          ...mineInfo.pagenation,
          tagId: 'setup',
          skip: 0,
          refresh: true,
        }),
      );
    }
  }, [userInfo]);

  useActivate(() => {
    // 因为从其他页面再次进入的时候不会再次请求接口，但是又要满足需求进入曾用页面需要展开批量添加引导 所以这强行打开
    dispatch(determineBatchShow({ groupType: 3, isShow: true }));
    handleShowBatchAdd({ groupType: 3 });
    dispatch(showBatchAddInfo(true));
  });

  useEffect(() => {
    if (userInfo && userInfo.st) {
      dispatch(determineBatchShow({ groupType: 3, isShow: true }));
      handleShowBatchAdd({ groupType: 3 });
    }
  }, [userInfo]);

  const handleShowBatchAdd = useCallback(async param => {
    const ret = await config.batchAddShow(param);
    if (ret?.status === 0) {
      if (ret?.data?.hasCarousel === 0) {
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'I_Wallpaper_Resiguid',
            label: '',
            param2: {
              type: 'spread',
              source: `Wallpaper_Mine||setup`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      }
    }
  }, []);

  const handleCancel = async params => {
    const typeActive = 4;
    if (typeActive !== params.type) {
      return;
    }
    const index = mineInfo.list.findIndex(item => item.wallpaperId === params.wallpaperId);
    dispatch(
      cancelMineCollectOrSetup({
        wallpaperId: params.wallpaperId,
        type: 4,
      }),
    );
    if (index > -1 && mineInfo.list.length < mineInfo.pagenation.count) {
      dispatch(
        getMineSetupList({
          ...mineInfo.pagenation,
          tagId: 'setup',
          skip: mineInfo.pagenation.skip - 1 > 0 ? mineInfo.pagenation.skip - 1 : 0,
          refresh: false,
        }),
      );
    }
  };

  const loadMore = () => {
    if (!mineInfo.load && mineInfo.pagenation.tagId === 'setup') {
      const params = {
        ...mineInfo.pagenation,
      };
      delete params.count;
      delete params.tagId;
      dispatch(
        getMineSetupList({
          ...mineInfo.pagenation,
          tagId: 'setup',
          refresh: false,
        }),
      );
      dispatch(showBatchAddInfo(false));
    }
  };

  // 监听浏览器大小变化自动适应
  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = useCallback(e => {
    const clientWidth = (document.body && document.body.clientWidth) || 1060;
    if (clientWidth < 1330) {
      setShowNumber(3);
    } else if (clientWidth >= 1330 && clientWidth < 1465) {
      setShowNumber(4);
    } else if (clientWidth >= 1465 && clientWidth < 1600) {
      setShowNumber(4);
    } else if (clientWidth >= 1600 && clientWidth < 1870) {
      setShowNumber(5);
    } else if (clientWidth >= 1870) {
      setShowNumber(6);
    }
  }, []);

  const getClassType = useCallback(
    (index = 0, number = '3') => {
      const series = {
        '3': {
          big: [1],
          big_space: [2, 0],
        },
        '4': {
          big: [1],
          big_space: [2, 3, 0],
        },
        '5': {
          big: [1],
          big_space: [2, 3, 4, 0],
        },
        '6': {
          big: [1],
          big_space: [2, 3, 4, 5, 0],
        },
      };
      const pos = (index + 1) % parseInt(number);
      let classType = 'small';
      if (series[number].big && series[number].big.indexOf(pos) > -1) {
        classType = 'small';
      }
      if (series[number].big_space && series[number].big_space.indexOf(pos) > -1) {
        classType = 'small_space';
      }
      return classType;
    },
    [showNumber],
  );

  const handleLogin = useCallback(() => {
    window.CallNativeMethod('logout');
    window.CallNativeMethod('login');
    // 点击 登录
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Login',
        label: '',
        param2: {
          source: `Wallpaper_Mine||setup`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch, logInfoData]);

  return (
    <div>
      {userInfo && userInfo.st && mineInfo.pagenation.count > -1 && (
        <InfiniteScroll
          pageStart={1}
          loadMore={loadMore}
          hasMore={mineInfo.list.length < mineInfo.pagenation.count}
          loader={
            <div className="loader" key={0}>
              --加载中--
            </div>
          }
          initialLoad={!mineInfo.list.length}
          useWindow={false}
          getScrollParent={() => node}
        >
          <div className={styles.mine}>
            {mineInfo.list.map((item, index) => {
              return (
                <WallpaperCard
                  wallpaper={item}
                  key={`${index}_${item.wallpaperId}`}
                  cardInfo={{
                    pageSource: 'mine',
                    pageTage: 'setup',
                    classType: getClassType(index, showNumber),
                    isCollect: true,
                    isWallpaper: true,
                    isPreview: true,
                    isDeleteColl: false,
                    isDeleteUsed: true,
                    allData: [...mineInfo.list],
                    deleteCallback: handleCancel,
                  }}
                  logInfo={{ source: `Wallpaper_Mine||setup` }}
                />
              );
            })}
          </div>

          {mineInfo.list.length >= mineInfo.pagenation.count && mineInfo.pagenation.count !== 0 && (
            <div className="loader">--到底啦--</div>
          )}
        </InfiniteScroll>
      )}
      {!userInfo ||
        (userInfo && !userInfo.st && (
          <div className={styles.nologin}>
            <div className={styles.blank}>
              <div className={styles.blank_img}>
                <img src={hint} alt="" className={styles.backColor} />
              </div>
              <div className={styles.text}>
                登录后，查看“ 曾用壁纸 ” <span onClick={handleLogin}>立即登录</span>
              </div>
            </div>
          </div>
        ))}
      {userInfo && userInfo.st && mineInfo.pagenation.count < 1 && mineInfo.list?.length < 1 && (
        <div className={styles.blank}>
          <Blank load={mineInfo.load} />
        </div>
      )}
      <div className={styles.right_control}>
        <ScrollTopWhite node={node} quickly={true} />
        {wpBatchAddShow.isShow && userInfo && userInfo.st && mineInfo.pagenation.count > 0 && (
          <BatchAdd
            scollNode={node}
            text={{ info: '曾用壁纸', classid: 0, tagid: 0 }}
            submitJson={{ groupType: 3 }}
            source={'Wallpaper_Mine||setup'}
          />
        )}
      </div>
    </div>
  );
});
